import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      cursor: 'pointer',
      height: 48,
      justifyContent: 'center',
      background: 'linear-gradient(278deg, #3F4C66 40.38%, #694A78 129.86%)',
      borderRadius: 8,
      padding: theme.spacing(1.5),
      border: 'unset',
    },
    content: {
      display: 'flex',
      alignItems: 'center',
      columnGap: theme.spacing(1.5),
      flex: 1,
    },
    img: {},
    title: {
      display: 'block',
      flex: 1,
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      fontWeight: theme.typography.fontWeightBold,
      fontFamily: theme.typography.DMSans,
      color: COLORS.neutral.silver,
      whiteSpace: 'nowrap',
    },
  }),
  { name: 'ButtonExtension' }
);
